import React from 'react';
import {KpiProps} from "../../../../../../types/types";
import {snakeCaseToWorld} from "../../../../../../utils/utils";
import "../SchedulerConfigurationStep.css";

export interface AggregateCardInfo {
    name: string,
    description: string
    selected: boolean;
    onToggle: (name: string, flag: boolean) => void
}

const AggregateCard: React.FC<AggregateCardInfo & KpiProps> = (props): JSX.Element => {

    return (
        <div onClick={() => props.onToggle(props.name, !props.selected)}
             className={"pointer aggregation-box " + (props.selected ? "aggregation-box-selected" : "")}>
            <h2>{snakeCaseToWorld(props.name)}</h2>
            <p>{props.description}</p>
        </div>
    )
}


export default AggregateCard;

